import script from "./AddMarkerCategoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMarkerCategoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddMarkerCategoryComponent.vue?vue&type=style&index=0&id=27ca9a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ca9a86"]])

export default __exports__